import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

const Composite2 = ({ data }) => (
  <div className="composite__wrapper">
    <div className="composite" id="comp2">
      <div className="comp__image-wrapper" id="comp2-image1">
        <StaticImage
          src="../../assets/images/truck-1.jpg"
          alt="This is the upper left portion of a composite of four images that make up one image of the rest stop that Kate's father used to take her to when she was a child. In this portion of the composite are the upper portions of trees: hardwoods and conifers. Some of the limbs in this portion of the image contain brown leaves."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp2-image2">
        <StaticImage
          src="../../assets/images/truck-2.jpg"
          alt="This is the upper right portion of a composite of four images that make up one image of the rest stop that Kate's father used to take her to when she was a child. This portion of the composite contains a gray sky. In the foreground to the left is a lower portion of a tree. Further back, dividing the sky are the tops of various trees, all devoid of leaves."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp2-image3">
        <StaticImage
          src="../../assets/images/truck-3.jpg"
          alt="This is the bottom right portion of a composite of four images that make up one image of the rest stop that Kate remembers being taken to as a child. This portion of the composite shows a grass lawn and the base of the trees interrupting a gray sky above. A solitary orange cone rests on the lawn between two trees. Beyond, in the parking lot of the rest stop, is a red semi truck hauling a white trailer. Farther back, another semi hauling a trailer full of cars and trucks."
          width={900}
        />
      </div>

      <div className="comp__image-wrapper" id="comp2-image4">
        <StaticImage
          src="../../assets/images/truck-4.jpg"
          alt="This is the bottom left portion of a composite of four images that make up one image of the rest stop that Kate remembers being taken as a child. This portion of the composite is filled with the bases of trees. A picnic table is partly obscured by the stand of trees. Another orange cone is slightly visible behind another tree. Beyond the trees is the parking lot of the rest stop, where the white trailer of a semi truck is parked."
          width={900}
        />
      </div>
    </div>
    <p className="benton-n4 composite__caption">{data.caption}</p>
  </div>
);

Composite2.propTypes = {
  data: PropTypes.shape({
    caption: PropTypes.string.isRequired,
  }).isRequired,
};

export default Composite2;
